import { render, staticRenderFns } from "./RotateIcon.vue?vue&type=template&id=6f848d84&"
import script from "./RotateIcon.vue?vue&type=script&lang=js&"
export * from "./RotateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports